import { render, staticRenderFns } from "./consultationQrView.vue?vue&type=template&id=065d82c8&scoped=true"
import script from "./consultationQrView.vue?vue&type=script&lang=js"
export * from "./consultationQrView.vue?vue&type=script&lang=js"
import style0 from "./consultationQrView.vue?vue&type=style&index=0&id=065d82c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065d82c8",
  null
  
)

export default component.exports